export type Report = {
  id: number
  requestingUser: number
  name: string
  start: string
  end: string
  requestedDatetime: string
  processingDatetime: string | null
  concludedDatetime: string | null
  status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED' | 'REMOVED'
  statusMessage: string
}
export type ReportDownload = Report & {
  signedUrl: string
}

export enum ReportFormat {
  EXCEL = 'EXCEL',
  CSV = 'CSV',
  JSON = 'JSON',
  JSON_LINES = 'JSON_LINES',
}
export type BaseReportTrigger = {
  fromDate?: Date
  toDate?: Date
  outputFormat: ReportFormat
}

export enum SmartShareReportType {
  ACTIVE = 'ACTIVE',
  HISTORICAL = 'HISTORICAL',
}
